import { bool, func, node, number } from "prop-types";

import styled from "styled-components/macro";

import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";
import FnrFade from "UI/FnrFade/FnrFade";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

const ChildrenContainer = styled("div")`
  margin-left: 24px;
`;

const ContainerSwitch = ({ addMargin, children }) =>
  addMargin ? <ChildrenContainer>{children}</ChildrenContainer> : children;

ContainerSwitch.propTypes = { addMargin: bool, children: node };

const FnrCheckNReveal = ({
  CheckboxComponent = FnrCheckbox,
  isActive,
  on = isActive,
  children,
  revealedChildren,
  addMargin,
  gap = 8,
  ...rest
}) => (
  <FnrVerticalGap gap={gap} data-cy="FnrCheckNReveal_Container">
    <CheckboxComponent on={on} isActive={on} {...rest}>
      {children}
    </CheckboxComponent>
    <FnrFade show={on}>
      <ContainerSwitch addMargin={addMargin}>
        {revealedChildren}
      </ContainerSwitch>
    </FnrFade>
  </FnrVerticalGap>
);

FnrCheckNReveal.propTypes = {
  /** The checkbox to be used. Must accept "on" as a prop */
  CheckboxComponent: func,
  /** proxy for on */
  isActive: bool,
  /** Passed down to CheckboxComponent  */
  on: bool,
  /** The content to be revealed */
  revealedChildren: node.isRequired,
  /** Adds indentation and padding-top when true */
  addMargin: bool,
  gap: number,
  children: node,
};

export default FnrCheckNReveal;
